export default __webpack_public_path__ + "static/media/linkedin-icon-default-state.dbab1868.svg";